import styled from 'styled-components';

export const PreviewVideoStyled = styled.div`
  .Polaris-MediaCard__ActionContainer {
    .Polaris-ButtonGroup {
      .Polaris-ButtonGroup__Item:first-child {
        button {
          position: relative;
          background: var(--pc-button-color);
          border-width: 0;
          border-color: transparent;
          box-shadow: var(--p-shadow-200);
          color: var(--pc-button-text);

          --pc-button-color: var(--p-color-bg-fill-brand);
          --pc-button-text: var(--p-color-text-brand-on-bg-fill);
          --pc-button-color-hover: var(--p-color-bg-fill-brand-hover);
          --pc-button-color-active: var(--p-color-bg-fill-brand-active);
          --pc-button-color-depressed: var(--p-color-bg-fill-brand-active);

          &::before {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0.07) 80%, rgba(255, 255, 255, 0.15) 100%);
            box-shadow: var(--p-shadow-button-primary);
            border-radius: 0.5625rem;
            transition: opacity 75ms cubic-bezier(0.19, 0.91, 0.38, 1);
          }

          svg {
            fill: var(--pc-button-text);
          }
        }
      }
    }
  }
`;
